var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7131 33.9272L28.4986 40.7126L43.4265 25.7847",
    stroke: "#02BF8E",
    strokeWidth: 5.42857
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5699 59.7116C36.5227 59.7116 39.8177 56.8949 40.5572 53.1592C40.637 52.7561 41.1393 52.548 41.4808 52.7766C44.6453 54.8953 48.9668 54.5571 51.7619 51.762C54.557 48.9669 54.8952 44.6453 52.7765 41.4808C52.5479 41.1393 52.7559 40.637 53.1591 40.5572C56.8948 39.8177 59.7116 36.5228 59.7116 32.5699C59.7116 28.6171 56.8949 25.3221 53.1592 24.5826C52.7561 24.5028 52.548 24.0005 52.7766 23.659C54.8953 20.4945 54.5571 16.1729 51.762 13.3778C48.9669 10.5828 44.6453 10.2446 41.4808 12.3633C41.1393 12.5919 40.637 12.3838 40.5572 11.9807C39.8177 8.24492 36.5227 5.42822 32.5699 5.42822C28.6171 5.42822 25.3221 8.24487 24.5826 11.9806C24.5028 12.3837 24.0005 12.5918 23.659 12.3632C20.4945 10.2445 16.1729 10.5827 13.3778 13.3778C10.5828 16.1729 10.2446 20.4945 12.3633 23.659C12.5919 24.0004 12.3838 24.5028 11.9807 24.5826C8.24492 25.3221 5.42822 28.617 5.42822 32.5699C5.42822 36.5227 8.24487 39.8177 11.9806 40.5572C12.3837 40.637 12.5918 41.1393 12.3631 41.4808C10.2445 44.6453 10.5827 48.9668 13.3778 51.7619C16.1729 54.557 20.4945 54.8952 23.659 52.7765C24.0004 52.5479 24.5028 52.7559 24.5826 53.1591C25.322 56.8949 28.617 59.7116 32.5699 59.7116Z",
    stroke: "#02BF8E",
    strokeWidth: 5.42857
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.4997b34c.svg";
export { ForwardRef as ReactComponent };